import { render, staticRenderFns } from "./SupplierBalance.vue?vue&type=template&id=4c3f15f8&scoped=true"
import script from "./SupplierBalance.vue?vue&type=script&lang=js"
export * from "./SupplierBalance.vue?vue&type=script&lang=js"
import style0 from "./SupplierBalance.vue?vue&type=style&index=0&id=4c3f15f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f15f8",
  null
  
)

export default component.exports